import Backbone from 'backbone';
import UserPreferences from 'models/user/UserPreferences';
import { isReadonlyMode, isProductSupportMode, isRaceManagementMode } from 'system/SystemUtil';

let globalUserPreferencesObject;

if (
    (isReadonlyMode() || isProductSupportMode() || isRaceManagementMode()) &&
    !location.pathname.includes('delegation-authorization')
) {
    globalUserPreferencesObject = new UserPreferences(JSON.parse(localStorage.getItem('viewerUserPreferences')));
    globalUserPreferencesObject.updateLocalizerAndPersonalizer();
} else {
    if (!window.VIEWER_USERPREFERENCES) {
        throw `Error: Viewer User Preferences is required.  To troubleshoot see ${
            window.location.origin
        }/userprofile-service/userprofile/settings`;
    }
    globalUserPreferencesObject = new UserPreferences(window.VIEWER_USERPREFERENCES);
    globalUserPreferencesObject.updateLocalizerAndPersonalizer();
    delete window.VIEWER_USERPREFERENCES; // Should no longer be accessed
}

export default globalUserPreferencesObject;
